import Vue from 'vue';
import axios from 'axios';
import router from 'src/router';
import { Message } from 'element-ui';

// 先判断环境
if (!!location.port) {
    Vue.prototype.HOST_PROXY_ADMIN = 'https://merchant-admin.starklotus.com'
} else {
    Vue.prototype.HOST_PROXY_ADMIN = location.origin.replace('ares', 'admin')
}

// 创建axios实例
const axiosInstance = axios.create({
    baseURL: Vue.prototype.HOST_PROXY_ADMIN,
    timeout: 25000,
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(function (config) {
    config.data = config.data ? config.data : {}
    config.emulateJSON = true;
    config.withCredentials = true;
    config.headers['X-TOKEN'] = localStorage.getItem('x-token');
    config.headers['Content-Type'] = 'application/json;charset:utf-8';
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
axiosInstance.interceptors.response.use(function (response) {
    // 用户未登陆 或者 用户被禁用，重定向到登录页面
    if (response.data.code == 1001000) {
        localStorage.clear();
        router.replace({
            path: '/login',
        });
    }

    // 返回结果code编码不为0时，显示错误信息（如果是srv类的服务，无code）
    if (response.data.code != 0) {
        Message({
            message: response.data.message,
            type: 'error',
            duration: 3000,
        });
        return Promise.reject(response.data.message);
    }
    return response;
}, function (error) {
    Message({
        message: '网络错误，请稍后再试',
        type: 'error',
        duration: 1500,
    });
    return Promise.reject('网络错误，请稍后再试');
});

// 创建 API 实例，返回的数据层级较深，建议后续使用createAPI2Res
const createAPI = (url, method, config = {}) => {
    return axiosInstance({
        url,
        method,
        ...config
    });
};

/**
 * @function createAPI2Res  创建 API 实例, 直接返回需要的data层级
 * @param {String} url 
 * @param {String} method 
 * @param {Object} config 
 * @returns {Promise}
 * @example 
 * @see {@link ./modules/mudule.js}
 */
const createAPI2Res = (url, method, config = {}) => {
    return new Promise((resolve, reject) => {
        axiosInstance({
            url,
            method,
            ...config
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        });
    })
};

export default createAPI;

export { createAPI, createAPI2Res }



// WEBPACK FOOTER //
// ./src/api/axios.js